
import { TextMediaComponent } from './TextMediaModule';
import Cta from './Cta.vue';
import TextBlock from './TextBlock.vue';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
import { LayoutOrientation } from './TextMediaModule.enums';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import owcDataComponent from '@owc-utils/Mixins/OwcDataComponent';
import { setUpWbSlider } from '@owc-utils/Workbench/slider-utils';
import Personalisation from '@owc-utils/Mixins/Personalisation';
import { getLocalFootnotes, setModuleId } from '@owc-utils/Footnotes/FootnotesHelper';
import { setBrandTheme } from '@owc-utils/Theming/theming';

/**
 * TextMediaModule Component for OneWeb
 * The Text Media module is a combined module of media, text content and call-to-action button.
 * Inside the module, the author could choose 3 types of content to fill:
 *  - Text (Subtitle, Headline and description)
 *  - Media (Image, Video or Slider)
 *  - Button
 * The behavior of the module needs to follow the content.
 * That means the author fill all fields the content need and the module automatically change in the website output.
 * **/

const sliderClasses = ['wb-slider__item', 'wb-slider__item--full-width'];

export default (ComponentInitializeDispatcher as TextMediaComponent).extend({
  name: 'owc-text-media-module',
  mixins: [owcDataComponent, Personalisation],
  components: {
    Cta,
    TextBlock,
    SlotContainer,
    ValidationBoxWrapper,
  },
  data() {
    return {
      sliderInitialized: false,
    };
  },
  computed: {
    buttonData: function() {
      return this.personaliseableData?.buttonData;
    },
    isPartOfAccordion: function() {
      return Boolean(this.personaliseableData?.isPartOfAccordion);
    },
    textBlock: function() {
      return this.personaliseableData?.textBlock;
    },
    isCTAVisible: function() {
      return Boolean(this.personaliseableData?.buttonData);
    },
    isTextOnLeft: function() {
      return this.personaliseableData?.layoutOrientation === LayoutOrientation.left;
    },
    isMediaContainer: function() {
      return Boolean(this.personaliseableData?.isMediaContainer);
    },
    shouldAddOffsetToText: function() {
      return !this.isMediaContainer && this.hasHeadline;
    },
    hasHeadline: function() {
      return Boolean(this.personaliseableData?.textBlock?.headline);
    },
    isDarkModeOn: function() {
      return Boolean(this.personaliseableData?.darkMode);
    },
    theme: function() {
      return this.isDarkModeOn ? 'dark' : 'light';
    },
    footnotes() {
      return getLocalFootnotes(this.personaliseableData);
    },
    moduleId() {
      return setModuleId(this);
    },
    brand() {
      return setBrandTheme();
    },
  },
  watch: {
    personaliseableData(data) {
      if (data) {
        const slider = this.$refs.wbSlider as HTMLTemplateElement;

        if (slider && !this.sliderInitialized) {
          setUpWbSlider(slider, sliderClasses);

          this.sliderInitialized = true;
        }
      }
    },
  },
});
